"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var platform_browser_1 = require("@angular/platform-browser");
var MultilineSvgPipe = /** @class */ (function () {
    function MultilineSvgPipe(sanitizer) {
        this.sanitizer = sanitizer;
        this.output = [];
        this.escapeHtmlMap = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#039;'
        };
        this.escapeHtmlRegExp = /[&<>"']/g;
    }
    MultilineSvgPipe.prototype.transform = function (inputText, maxLength, maxLines, tSpan, convertCase) {
        var _this = this;
        if (maxLength === void 0) { maxLength = 27; }
        if (maxLines === void 0) { maxLines = 10; }
        if (tSpan === void 0) { tSpan = true; }
        if (convertCase === void 0) { convertCase = null; }
        this.output.length = 0;
        if (convertCase === true) {
            inputText = (inputText || '').toUpperCase();
        }
        if (convertCase === false) {
            inputText = (inputText || '').toLowerCase();
        }
        var textParts = (inputText || '').split(' ');
        var position = 0;
        var outputText = '';
        textParts.forEach(function (text) {
            _this.output[position] = ((_this.output[position] || '') + ' ' + text).trim();
            if (_this.output[position].length >= maxLength) {
                position++;
            }
        });
        if (this.output.length && this.output.length > maxLines) {
            this.output.length = maxLines;
            this.output[this.output.length - 1] = this.output[this.output.length - 1] + '…';
        }
        this.output.forEach(function (text, index) {
            outputText += tSpan ? '<tspan x="50%" dy="' + (index === 0 ? 5 - (_this.output.length - 1) * 10 : 20) + '">' + _this.escapeHtml(text) + '</tspan>' : text;
        });
        return tSpan ? this.sanitizer.bypassSecurityTrustHtml(outputText) : outputText;
    };
    MultilineSvgPipe.prototype.escapeHtml = function (text) {
        var _this = this;
        return text.replace(this.escapeHtmlRegExp, function (m) {
            return _this.escapeHtmlMap[m];
        });
    };
    MultilineSvgPipe.decorators = [
        { type: core_1.Pipe, args: [{
                    name: 'multilineSvgText',
                    pure: true,
                },] },
    ];
    /** @nocollapse */
    MultilineSvgPipe.ctorParameters = function () { return [
        { type: platform_browser_1.DomSanitizer, },
    ]; };
    return MultilineSvgPipe;
}());
exports.MultilineSvgPipe = MultilineSvgPipe;
//# sourceMappingURL=multiline-svg.pipe.js.map